import React from 'react';
import { getBunnyOptimizedImageUri, htmlToPlainText } from '@annunciate/ui';
import { usePageTitle } from '../hooks';
export const MetaTags = ({ title = '', description = '', image, type = 'website', card = 'summary_large_image', settings, }) => {
    const { description: siteDescription } = settings?.meta || {};
    const truncateText = (text, maxLength) => text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    const pageTitle = usePageTitle(title, settings?.meta);
    const truncatedTitle = truncateText(pageTitle, 60);
    const cleanDescription = htmlToPlainText(description || siteDescription);
    const truncatedDescription = truncateText(cleanDescription, 200);
    const optimizedImage = getBunnyOptimizedImageUri(image, { aspectRatio: '1.9:1' });
    return (React.createElement(React.Fragment, null,
        React.createElement("meta", { name: "description", content: truncatedDescription }),
        React.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
        React.createElement("link", { rel: "icon", href: "/favicon.ico" }),
        React.createElement("meta", { property: "og:title", content: truncatedTitle }),
        React.createElement("meta", { property: "og:description", content: truncatedDescription }),
        React.createElement("meta", { property: "og:type", content: type }),
        React.createElement("meta", { property: "og:image", content: optimizedImage }),
        React.createElement("meta", { name: "twitter:title", content: truncatedTitle }),
        React.createElement("meta", { name: "twitter:description", content: truncatedDescription }),
        React.createElement("meta", { name: "twitter:card", content: card }),
        React.createElement("meta", { name: "twitter:image", content: optimizedImage })));
};
//# sourceMappingURL=MetaTags.js.map